import { AuthState } from './types'

export const initialState: AuthState = {
	token: '',
	user: null,
	pendingAccess: '',
	error: '',
	loading: false
}
